import { useMemo, useCallback } from "react";
import { useToast as useToastContext } from "../context/Toast/ToastContext";

export const useToast = () => {
  const toast = useToastContext();

  // ✅ Memoizar showToast para manter referência estável
  const showToast = useCallback(
    (message, type = "info", options = {}) => {
      return (
        toast[type]?.(message, options) || toast.addToast(message, type, options)
      );
    },
    [toast]
  );

  // ✅ Memoizar objeto retornado para evitar loops em useEffect/useCallback
  return useMemo(
    () => ({
      success: toast.success,
      error: toast.error,
      warning: toast.warning,
      info: toast.info,

      showToast,

      removeToast: toast.removeToast,
      removeAllToasts: toast.removeAllToasts,

      toasts: toast.toasts,
    }),
    [toast, showToast]
  );
};

export default useToast;
